<template>
    <el-tooltip class="item" effect="dark" :content="menuOption.description" placement="top-start" v-if="menuOption.children.length === 0">
      <router-link tag="li"
        :id="menuOption.name"
        :key="menuOption.name"
        :to="{ name: menuOption.name }">
          <a>{{ getOptionTitle(menuOption.title) }}</a>
      </router-link>
    </el-tooltip>
    <li class="dropdown" v-else
      :key="menuOption.name"
      :class="{'active': subMenuIsActive(menuOption.path)}"
      @click="handleClickDropdownMenu()">
        <a :id="menuOption.name" href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
            aria-expanded="false">
            {{ getOptionTitle(menuOption.title) }} <span class="caret"></span>
        </a>
        <ul class="dropdown-menu">
            <template v-for="menuOptionChildren in menuOption.children">
              <el-tooltip :key="menuOptionChildren.name" class="item" effect="dark" :content="menuOptionChildren.description" placement="right-start">
              <router-link tag="li"
                :to="{ name: menuOptionChildren.name }">
                  <a>{{ getOptionTitle(menuOptionChildren.title) }}</a>
              </router-link>
              </el-tooltip>
            </template>
        </ul>
    </li>
</template>

<script>
import { isFunction } from 'lodash';

export default {
  props: ['menuOption'],
  methods: {
    getOptionTitle(title) {
      if (isFunction(title)) {
        return title.call(this, this.$route.params);
      }
      return title;
    },
    subMenuIsActive(path) {
      return this.$route.path.indexOf(path) === 0;
    },
    handleClickDropdownMenu() {
      window.jQuery('[data-toggle="tooltip"]').tooltip({ trigger: 'hidden' });
    },
  },
  mounted() {
    window.jQuery('[data-toggle="tooltip"]').tooltip();
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/menu.vue